
<template>
  <div>
    <SubHeader title="Business Contact Information" />
    <b-alert v-if="callLocation === 'business' && (callInProgress || callResult)" show :variant="callInProgress ? 'info' : callResult.accepted ? 'success' : 'danger'">
      <b-spinner v-if="callInProgress" small label="Starting call"></b-spinner>
      {{ callInProgress ? 'Starting call...' : callResult.message }}
    </b-alert>
    <b-form @submit="onSubmit" class="container" v-if="company && companyVendors">
      <b-row class="my-1">
        <b-col md="3" class="label">
          <label for="telephoneNumberBusiness"
                 v-bind:class="{red: company.doNotUseTelephoneNumberBusiness == true || company.telephoneNumberBusinessCtps == true}">Business Telephone (1)</label>
        </b-col>
        <b-col md="4">
          <b-form-input id="telephoneNumberBusiness"
                        v-model="company.telephoneNumberBusiness"
                         v-bind:class="{red: company.doNotUseTelephoneNumberBusiness == true || company.telephoneNumberBusinessCtps == true}"
                        :disabled="onTheMarket"></b-form-input>
        </b-col>
        <b-col md="2">
          <div v-if="hasAgentId">

          </div>
          <b-button v-if="enableCallButtons && !company.doNotUseTelephoneNumberBusiness"
                     variant="info"
                     type="button"
                     :disabled="callInProgress"
                     @click="makeCall(company.telephoneNumberBusiness, null, 'business')"
                    ><font-awesome-icon icon="phone" />&nbsp;Call</b-button>
        </b-col>
        <b-col md="3">
          <b-form-checkbox v-model="company.doNotUseTelephoneNumberBusiness" name="checkbox-1" :disabled="onTheMarket">
            Do Not Use
          </b-form-checkbox>
        </b-col>
      </b-row>
      <b-row v-if="company.telephoneNumberBusinessCtps == true">
        <b-col>
          <b-alert variant="danger" show>
          <small>CTPS ONLY USE IF PERMISSION IS GIVEN</small>
        </b-alert>
        </b-col>        
      </b-row>
      <b-row class="my-1">
        <b-col md="3" class="label">
          <label for="telephoneNumberBusinessAlternative"
                 v-bind:class="{red: company.doNotUseTelephoneNumberBusinessAlternative == true || company.telephoneNumberBusinessAlternativeCtps == true}">
            Business Telephone (2)
          </label>
        </b-col>
        <b-col md="4">
          <b-form-input id="telephoneNumberBusinessAlternative"
                        v-model="company.telephoneNumberBusinessAlternative"
                        v-bind:class="{red: company.doNotUseTelephoneNumberBusinessAlternative == true || company.telephoneNumberBusinessAlternativeCtps == true}"
                        :disabled="onTheMarket"></b-form-input>
        </b-col>
        <b-col md="2">
           <b-button v-if="enableCallButtons && !company.doNotUseTelephoneNumberBusinessAlternative" variant="info"
                     type="button"
                     :disabled="callInProgress"
                     @click="makeCall(company.telephoneNumberBusinessAlternative, null, 'business')"><font-awesome-icon icon="phone"
                    />&nbsp;Call</b-button>
        </b-col>
        <b-col md="3">
          <b-form-checkbox v-model="company.doNotUseTelephoneNumberBusinessAlternative" :disabled="onTheMarket">
            Do Not Use
          </b-form-checkbox>
        </b-col>
      </b-row>
      <b-row v-if="company.telephoneNumberBusinessAlternativeCtps == true">
        <b-col>
          <b-alert variant="danger" show>
          <small>CTPS ONLY USE IF PERMISSION IS GIVEN</small>
        </b-alert>
        </b-col>        
      </b-row>
      <b-row class="my-1">
        <b-col md="3" class="label">
          <label for="emailAddress"
                 v-bind:class="{red: company.doNotUseEmailAddress == true}">General Email (1)</label>
        </b-col>
        <b-col md="6">
          <b-form-input id="emailAddress"
                        v-model="company.emailAddress"
                        v-bind:class="{red: company.doNotUseEmailAddress == true}"
                        :disabled="onTheMarket"></b-form-input>
        </b-col>
        <b-col md="3">
          <b-form-checkbox v-model="company.doNotUseEmailAddress" :disabled="onTheMarket">
            Do Not Use
          </b-form-checkbox>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col md="3" class="label">
          <label for="emailAddressAlternative"
                 v-bind:class="{red: company.doNotUseEmailAddressAlternative == true}">General Email (2)</label>
        </b-col>
        <b-col md="6">
          <b-form-input id="emailAddressAlternative"
                        v-model="company.emailAddressAlternative"
                        v-bind:class="{red: company.doNotUseEmailAddressAlternative == true}"
                        :disabled="onTheMarket"></b-form-input>
        </b-col>
        <b-col md="3">
          <b-form-checkbox v-model="company.doNotUseEmailAddressAlternative" :disabled="onTheMarket">
            Do Not Use
          </b-form-checkbox>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col md="3" class="label">

        </b-col>
        <b-col md="6">
          <b-button class="my-1 margin-right"
                    variant="success"
                    type="submit"
                    :disabled="onTheMarket"><font-awesome-icon icon="save" />&nbsp;Save</b-button>
          <b-button class="my-1"
                    variant="danger"
                    type="button"
                    @click="reset()"
                    :disabled="onTheMarket"><font-awesome-icon icon="times" />&nbsp;Cancel Changes</b-button>
        </b-col>
      </b-row>

      <b-row class="my-1">
        <b-col md="3">
        </b-col>
        <b-col md="6">
          <Feedback ref="saveFeedback" />
        </b-col>
      </b-row>
    </b-form>

    <SubHeader title="Shareholder Details" />
    <b-alert v-if="callLocation === 'shareholders' && (callInProgress || callResult)" show :variant="callInProgress ? 'info' : callResult.accepted ? 'success' : 'danger'">
      <b-spinner v-if="callInProgress" small label="Starting call"></b-spinner>
      {{ callInProgress ? 'Starting call...' : callResult.message }}
    </b-alert>

    <div v-if="shareholders.length > 0">
      <ContactRow :vendors="shareholders" :lookups="this.lookups" :readonly="onTheMarket" :enableCallButtons="this.enableCallButtons" :callInProgress="callInProgress" callLocation="shareholders" @makeCall="makeCall"></ContactRow>
    </div>
    <div v-if="shareholders.length == 0">
      <b-alert variant="info" show><strong>No Shareholders</strong> have been added for this Company</b-alert>
    </div>
    <b-button class="margin-bottom"
              variant="primary"
              type="button"
              :disabled="onTheMarket"
              @click="addShareholder">
      <font-awesome-icon icon="plus" />&nbsp;Add Shareholder
    </b-button>

    <SubHeader title="Director Details" />
    <b-alert v-if="callLocation === 'directors' && (callInProgress || callResult)" show :variant="callInProgress ? 'info' : callResult.accepted ? 'success' : 'danger'">
      <b-spinner v-if="callInProgress" small label="Starting call"></b-spinner>
      {{ callInProgress ? 'Starting call...' : callResult.message }}
    </b-alert>

    <div v-if="directors.length > 0">
      <ContactRow :vendors="directors" :lookups="this.lookups" :readonly="onTheMarket" :enableCallButtons="this.enableCallButtons" :callInProgress="callInProgress" callLocation="directors" @makeCall="makeCall"></ContactRow>
    </div>
    <div v-if="directors.length == 0">
      <b-alert variant="info" show><strong>No Directors</strong> have been added for this Company</b-alert>
    </div>
    <b-button class="margin-bottom"
              variant="primary"
              type="button"
              :disabled="onTheMarket"
              @click="addDirector">
      <font-awesome-icon icon="plus" />&nbsp;Add Director
    </b-button>

    <SubHeader title="Other Details" />
    <b-alert v-if="callLocation === 'others' && (callInProgress || callResult)" show :variant="callInProgress ? 'info' : callResult.accepted ? 'success' : 'danger'">
      <b-spinner v-if="callInProgress" small label="Starting call"></b-spinner>
      {{ callInProgress ? 'Starting call...' : callResult.message }}
    </b-alert>

    <div v-if="others.length > 0">
      <ContactRow :vendors="others" :lookups="this.lookups" :readonly="onTheMarket" :enableCallButtons="this.enableCallButtons" :callInProgress="callInProgress" callLocation="others" @makeCall="makeCall"></ContactRow>
    </div>
    <div v-if="others.length == 0">
      <b-alert variant="info" show><strong>No Vendors</strong> have been added for this Company</b-alert>
    </div>
    <b-button class="margin-bottom"
              variant="primary"
              type="button"
              :disabled="onTheMarket"
              @click="addOther">
      <font-awesome-icon icon="plus" />&nbsp;Add Vendor
    </b-button>

    <ContactEdit :vendor="selectedVendor" :lookups="lookups" :company="company" :addingShareholder="addingShareholder" :addingDirector="addingDirector" ref="editVendorModal" />
  </div>
</template>

<script>
  import SubHeader from "@/components/shared/SubHeader.vue";
  import Feedback from "@/components/shared/Feedback.vue";
  import ContactRow from "@/components/company/contacts/ContactRow.vue";
  import CompanyService from "@/services/Company.service";
  import ContactEdit from "@/components/company/contacts/ContactEdit.vue";

  export default {
    name: "CompanyContact",
    components: { SubHeader, ContactRow, ContactEdit, Feedback },
    props: {
      initialCompany: Object,
      initialCompanyVendors: Array,
      lookups: Object,
      enableCallButtons: Boolean,
      callInProgress: Boolean,
      callLocation: String,
      callResult: Object
    },
    mounted() {
      if (this.initialCompany && this.company == null) {
        this.company = { ...this.initialCompany };
      }
      if (this.initialCompanyVendors && this.companyVendors == null) {
        this.companyVendors = { ...this.initialCompanyVendors };
      }
    },
    watch: {
      initialCompany: function () {
        this.company = { ...this.initialCompany };
        this.onTheMarket = this.initialCompany.companyLocked;
      },
      initialCompanyVendors: function () {
        this.companyVendors = [...this.initialCompanyVendors];
      },
    },
    data() {
      return {
        company: null,
        companyVendors: [],
        groupFields: [],
        selectedVendor: null,
        addingDirector: false,
        addingShareholder: false,
        onTheMarket: false,

        blankVendor: {
          additionalNotes: null,
          age: null,
          companyId: null,
          companyVendorPreferredContactMethodId: 0,
          companyVendorPreferredContactNumberId: 0,
          companyVendorPreferredContactTimeHour: null,
          companyVendorPreferredContactTimeMinute: null,
          companyVendorRoleId: 0,
          companyVendorSource: null,
          correspondenceAddressCounty: null,
          correspondenceAddressLine1: null,
          correspondenceAddressLine2: null,
          correspondenceAddressLine3: null,
          correspondenceAddressLine4: null,
          correspondenceAddressLine5: null,
          correspondenceAddressTown: null,
          correspondenceInstructions: null,
          correspondencePostcode: null,
          defaultMainContact: false,
          doNotUseEmailAddress: false,
          doNotUseEmailAddressAlternative: false,
          doNotUsePreferredContactNumber: false,
          doNotUseTelephoneAlternative: false,
          doNotUseTelephoneBusiness: false,
          doNotUseTelephoneMobile: false,
          emailAddress: null,
          emailAddressAlternative: null,
          firstName: null,
          fullname: null,
          isAdvisor: false,
          isBuyerMainContact: false,
          isDirector: false,
          isMainContact: false,
          isShareholder: false,
          knownAs: null,
          lastName: null,
          position: null,
          shareholderSinceMonth: null,
          shareholderSinceYear: null,
          shareholding: null,
          telephoneAlternative: null,
          telephoneAlternativeCtps: false,
          telephoneBusiness: null,
          telephoneBusinessCtps: false,
          telephoneMobile: null,
          telephoneMobileCtps: false,
          title: null
        }
      };
    },
    computed: {
      shareholders: function () {
        if (!this.companyVendors) return [];
        return this.companyVendors.filter(x => x.isShareholder)
      },
      directors: function () {
        if (!this.companyVendors) return [];
        return this.companyVendors.filter(x => x.isDirector && !x.isShareholder)
      },
      others: function () {
        if (!this.companyVendors) return [];
        return this.companyVendors.filter(x => !x.isShareholder && !x.isDirector)
      }
    },
    methods: {
      onSubmit(evt) {
        evt.preventDefault();

        var save = {
          Id: this.company.id,
          TelephoneNumberBusiness: this.company.telephoneNumberBusiness,
          TelephoneNumberBusinessAlternative: this.company.telephoneNumberBusinessAlternative,
          EmailAddress: this.company.emailAddress,
          EmailAddressAlternative: this.company.emailAddressAlternative,
          DoNotUseTelephoneNumberBusiness: this.company.doNotUseTelephoneNumberBusiness,
          DoNotUseTelephoneNumberBusinessAlternative: this.company.doNotUseTelephoneNumberBusinessAlternative,
          DoNotUseEmailAddress: this.company.doNotUseEmailAddress,
          DoNotUseEmailAddressAlternative: this.company.doNotUseEmailAddressAlternative
        }

        CompanyService.saveCompanyContactInformation(save).then(() => {
          // Reload vendors
          this.$parent.$parent.$parent.loadData()
          this.$refs.saveFeedback.showSuccess("Save Successful");
        })

      },
      reset() {
        this.company = { ...this.initialCompany };
        this.companyVendors = [...this.initialCompanyVendors];
        this.selectedVendor = null;
      },
      editVendor(vendor) {
        this.selectedVendor = { ...vendor };
        this.addingShareholder = false
        this.addingDirector = false
        this.$refs.editVendorModal.showModal()
      },
      addShareholder() {
        this.selectedVendor = { ...this.blankVendor }
        this.selectedVendor.companyId = this.company.id
        this.selectedVendor.isShareholder = true
        this.addingShareholder = true
        this.addingDirector = false
        this.$refs.editVendorModal.showModal()
      },
      addDirector() {
        this.selectedVendor = { ...this.blankVendor }
        this.selectedVendor.companyId = this.company.id
        this.selectedVendor.isDirector = true
        this.addingShareholder = false
        this.addingDirector = true
        this.$refs.editVendorModal.showModal()
      },
      addOther() {
        this.selectedVendor = { ...this.blankVendor }
        this.selectedVendor.companyId = this.company.id
        this.addingShareholder = false
        this.addingDirector = false
        this.$refs.editVendorModal.showModal()
      },
      makeCall(number, vendorId, location) {
        this.$emit('makeCall', number, vendorId, location);
      },
      hasAgentId() {
        return true;
      }
    }
  };
</script>

<style scoped>
  .label {
    text-align: right;
  }

    .label > label {
      margin-top: 6px;
    }
</style>
